module.exports = __webpack_public_path__ + "media/images/shared/bg-marble-a3a7441153e9c6e2bbfe4652b7e7c5cd.png";